import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import SummerBanner from "./components/SummerBanner";
import Hero from "./components/Hero";
import About from "./components/About";
import Program from "./components/Program";
import Activities from "./components/Activities";
import SummerCamp from "./components/SummerCamp";
import Pricing from "./components/Pricing";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => (
  <>
    <SummerBanner />
    <Navbar />
    <main>
      <Hero />
      <About />
      <Program />
      <Activities />
      <SummerCamp />
      <Pricing />
      <Gallery />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-center" richColors closeButton />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
